import { ValidationProps } from 'ui/common/validation/types';
import {
  validateComplexValue,
  validateIfNotEqual
} from 'app/area/codetable/item/screen-renderer/screen-validate/helpers';
import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CodeActionType } from 'app/area/codetable/item/types';
import { ValidationData } from 'app/area/codetable/item/validation/validate';
import { isCheckBoxReferenceType } from 'app/area/codetable/item/screen-renderer/screen-pickers/reference/helpers';
import { CodeFieldWireKey } from 'app/area/codetable/types-store';

export const validateReference = (validationData: ValidationData): { [key: string]: ValidationProps } => {
  const { codeItem, translation, actionType } = validationData;
  const isCodeEditing = codeItem && isDefinedIncludingZero(codeItem.id);

  const isCodeDuplicating = actionType === CodeActionType.Duplicate;

  const categoryValidation = validateComplexValue(CodeFieldWireKey.category, codeItem, translation);

  const shouldValidateCheckedUnchecked = !isCodeDuplicating && isCodeEditing && isCheckBoxReferenceType(codeItem);

  if (!shouldValidateCheckedUnchecked) {
    return { ...categoryValidation };
  }

  const checkedCodeValidation = validateComplexValue(ScreenPicker.checkedCode, codeItem, translation);
  const uncheckedCodeValidation = validateComplexValue(ScreenPicker.uncheckedCode, codeItem, translation);

  if ((!checkedCodeValidation || !checkedCodeValidation.checkedCode) &&
    (!uncheckedCodeValidation || !uncheckedCodeValidation.uncheckedCode)) {
    const checkedUncheckedNotSame =
      validateIfNotEqual(ScreenPicker.checkedCode, ScreenPicker.uncheckedCode, codeItem, translation.checked_unchecked_must_be_different);

    if (checkedUncheckedNotSame) {
      return checkedUncheckedNotSame;
    }
  }

  return {
    ...checkedCodeValidation,
    ...uncheckedCodeValidation
  };
};
